// extracted by mini-css-extract-plugin
module.exports = {"resetPasswordWrap":"styles_resetPasswordWrap__2FOmG","login_button":"styles_login_button__1b7Uo","register":"styles_register__32ant"};